import axios from "axios"; 
const URL = process.env.REACT_APP_API_URL;

export interface IResultCalculator {
  length: {
    additionPost: boolean;
    additionPre: boolean;
    factor: number;
    label: string;
    symbol: string;
    value: number;
  };
  weight: {
    additionPost: boolean;
    additionPre: boolean;
    factor: boolean;
    label: string;
    symbol: string;
    value: number;
  };
}

export const calculatorService = (payload) => {
  return axios.post(`${URL}/calculator/profile-calculator/calculate`, payload);
};
